import { render, staticRenderFns } from "./extra-category-list.vue?vue&type=template&id=61365094&scoped=true&lang=pug&"
import script from "./extra-category-list.vue?vue&type=script&lang=js&"
export * from "./extra-category-list.vue?vue&type=script&lang=js&"
import style0 from "./extra-category-list.vue?vue&type=style&index=0&id=61365094&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61365094",
  null
  
)

export default component.exports